export default __webpack_public_path__ + "static/media/marimba_chord_prompt.900c3815.mp3";